import React from "react";

const PaperHeader = ({ icon, title, rightEl }) => {
  return (
    <div className="d-flex align-items-center justify-content-between pb-2 mb-3 border-bottom">
      <div className="d-flex align-items-center">
        {icon}
        <h3 className="m-0 ms-3">{title}</h3>
      </div>
      {rightEl && <div className="d-flex align-items-center">{rightEl}</div>}
    </div>
  );
};

export default PaperHeader;
